export function isApproved(record, okcheck, field = '') {
  if (okcheck !== undefined && field !== okcheck) {
    return record.headerFields[okcheck] === '1';
  }
  return false;
}
